export default {
  path: 'homeshop/',
  props: true,
  component: () =>
    import(/* webpackChunkName: "homeshop-layout" */ '../HomeShopLayout.vue'),
  children: [
    {
      name: 'HomeShopMain',
      path: '',
      redirect: {
        name: 'MyHomeShop'
      }
    },
    {
      path: 'my-shop',
      name: 'MyHomeShop',
      props: true,
      meta: {
        defaultTab: 'homeshop-my'
      },
      component: () =>
        import(/* webpackChunkName: "homeshop-my" */ '../views/MyHomeShop')
    },
    {
      path: 'others',
      name: 'HomeShopOthers',
      props: true,
      meta: {
        defaultTab: 'homeshop-others'
      },
      component: () =>
        import(
          /* webpackChunkName: "homeshop-other" */ '../views/HomeShopOthers'
        )
    },
    {
      path: 'tournaments',
      name: 'HomeShopTournaments',
      props: true,
      meta: {
        defaultTab: 'homeshop-tournaments'
      },
      component: () =>
        import(
          /* webpackChunkName: "homeshop-tournament" */ '../views/HomeShopTournament'
        )
    },
    {
      path: 'players',
      name: 'MyHomeShopPlayer',
      props: true,
      meta: {
        defaultTab: 'homeshop-players'
      },
      component: () =>
        import(
          /* webpackChunkName: "homeshop-player" */ '../views/HomeShopPlayers'
        )
    }
  ]
}
